export enum ECatalog {
  REJECT_CAUSES= 'REJECT_CAUSES',
  LANGUAGE= 'LANGUAGE',
  COMPLAINTS_STATUS= 'COMPLAINTS_STATUS',
  IDENTIFICATION= 'IDENTIFICATION',
  COUNTRY= 'COUNTRY',
  STATES= 'STATES',
  RETAILERS= 'RETAILERS',
  REFERRER_RELATIONSHIP = 'REFERRER_RELATIONSHIP',
  AGENTS = 'agents',
  CITIZENSHIP = 'citizenship'
}
